import React from 'react';
import './PageTitle.css';

import { FaArrowRight, FaHome } from 'react-icons/fa';
import { Link } from 'react-router-dom';



const PageTitle = (props) => {

  // Destructuring props
  const { title, page } = props;

  return (
    <div className='page-title'>

      {/* Title Container */}
      <div className='title'>
        <h2>{title}</h2>
      </div>

      {/* Link and page Container */}
      <div className='link'>
        <Link to='/'><FaHome /></Link> {/* Link to the home page */}
        <FaArrowRight className='icon' /> {/* Icon indicating a link */}
        <span className='page'>{page}</span> {/* Page Title */}
      </div>

    </div>
  )
}

export default PageTitle;